// Karate / Japanese decorative motifs — pure inline SVG + CSS, NO external images.

const BELT_COLORS = ["#FFFFFF", "#EAB308", "#F97316", "#16A34A", "#2563EB", "#7C3AED", "#78350F", "#111827", "#8B181B"];

export function BeltStrip({ className = "" }) {
  return (
    <div className={`flex w-full ${className}`} aria-hidden="true" data-testid="belt-strip">
      {BELT_COLORS.map((c) => (
        <span key={c} style={{ backgroundColor: c }} className="flex-1" />
      ))}
    </div>
  );
}

// Ensō — the zen brush circle (left intentionally open).
export function EnsoRing({ className = "", stroke = "#C9A24B", strokeWidth = 5 }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden="true">
      <path
        d="M62 9 A44 44 0 1 1 33 12"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}

// Simplified torii gate silhouette.
export function ToriiGate({ className = "", color = "currentColor" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill={color} aria-hidden="true">
      <path d="M4 20 L96 20 L96 27 L84 27 L80 35 L20 35 L16 27 L4 27 Z" />
      <rect x="14" y="42" width="72" height="6" />
      <rect x="24" y="42" width="9" height="52" />
      <rect x="67" y="42" width="9" height="52" />
    </svg>
  );
}

// A stylized karateka (side-kick) silhouette.
export function Karateka({ className = "", color = "currentColor" }) {
  return (
    <svg viewBox="0 0 120 120" className={className} fill={color} aria-hidden="true">
      <circle cx="34" cy="20" r="9" />
      <path d="M30 30 C28 40 28 46 33 54 L30 78 L22 96 L31 96 L40 76 L44 58 L60 62 L100 52 L99 44 L62 50 L48 44 C46 40 44 36 42 32 Z" />
      <path d="M33 40 L14 48 L17 55 L38 49 Z" />
    </svg>
  );
}

export function KanjiWatermark({ children, className = "" }) {
  return (
    <span aria-hidden="true" className={`pointer-events-none select-none font-serif leading-none ${className}`}>
      {children}
    </span>
  );
}
